import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function createSuccess(draft: Draft<IUserData>) {
  draft.create.config.isLoading = false;
}

export default createSuccess;
